<template>
    <div class="notices_box">
        <div class="notices_container" :style="{ top: containerTop + 'px' }" ref="container"  @transitionend="transitionEnd">
            <div class="item flex between width100 height40px size16" v-for="item,index in list" :key="index">
                <p class="notices_title">恭喜{{ item.nickname }}拍得{{ item.goods_name }}</p>
                <p>{{ item.show_time }}</p>
            </div>
        </div>
        
    </div>
</template>

<script>
import ajax from "@/utils/request.js";

export default {
    data(){
        return{
            list:[],
            containerTop: 0,
            intervalId:null
        }
    },
    created(){
        this.init()
    },
    mounted() {
        this.startAnimation();
    },
    beforeUnmount() {
    // Clear the interval when the component is about to be unmounted
        clearInterval(this.intervalId);
    },
    methods:{
        init(){
            ajax.post("products/getauctionlist").then(res=>{
                if(res.errcode == 1){
                    this.list = res.data
                    this.list.push(this.list[0])
                }
            })
        },
        startAnimation() {

        this.intervalId = setInterval(() => {
            // 向上滚动
            this.containerTop -= 40;

            // 判断是否到达通知项的底部
            if (this.containerTop <= -40 * (this.list.length)) {
               this.containerTop = 0
               this.$refs.container.style.transition = "none";
               this.$nextTick(() => {
                    this.$refs.container.style.transition = "top 0.01s ease";
                });
            }
        }, 3000); // 调整滚动间隔时间
        },
        transitionEnd(){
            this.$refs.container.style.transition="top 0.5s ease";
        }
       
    },
}
</script>

<style lang="scss" scoped>
.notices_box{
    position: relative;
    left: 0;
    height: 40px;
    // padding:0 15px;
    background-color:#fff2ed ;
    color: #f1a385;
    overflow: hidden;
    .notices_container{
        position: absolute;
        width: 100%;
        padding:0 15px;
        transition: top 0.5s ease;
        .notices_title{
            width: 80%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
    .item{
        line-height: 40px;
    }
}

</style>